import { colors, fonts, breakpoints } from '@vfit/shared/themes';
import styled from 'styled-components';

// ModalWrapper - Outer container
export const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  border-radius: 25px !important;
  padding: 20px;

  a {
    padding: clamp(10px, 2vw, 12px) clamp(30px, 5vw, 60px);
    font-size: clamp(14px, 2.5vw, 14px);
    background-color: #e30613;
    color: ${colors.$ffffff}; /* Regular link color */
    border: none;
    border-radius: 25px;
    cursor: pointer;
    text-decoration: none;
    color: ${colors.$ffffff} !important;
    font-weight: 700 !important;

    :visited {
      color: ${colors.$ffffff} !important;
    }
    @media (max-width: ${breakpoints.desktop}) {
      width: 100%;
    }
  }

  @media (max-height: 500px) {
    font-size: 14px;
    padding: clamp(10px, 2vw, 5px) clamp(30px, 5vw, 20px);
  }

  @media (max-width: ${breakpoints.desktop}) {
    padding-top: 44px;
  }
`;

// ModalHeader - Scales dynamically
export const ModalHeader = styled.div`
  font-size: 36px; /* Dynamically scale font size */
  font-family: ${fonts.exbold};
  margin-bottom: 6px;
  text-align: left; /* Align center for better presentation */
  line-height: 1.2; /* Improve multi-line spacing */

  @media (max-height: 700px) {
    font-size: 36px;
  }
  @media (max-width: 800px) {
    font-size: 36px;
  }
`;

export const Link = styled.a`
  padding: clamp(10px, 2vw, 12px) clamp(30px, 5vw, 60px);
  font-size: clamp(12px, 2.5vw, 14px);
  background-color: #e30613;
  color: ${colors.$ffffff};  /* Regular link color */
  border: none;
  border-radius: 25px;
  cursor: pointer;
  text-decoration: none;

  /* Specific targeting for the modal link */
  &.modal-link {
    color: ${colors.$ffffff}; !important; /* Ensure link color is white */
  }

  &:visited {
    color: ${colors.$ffffff}; !important /* Ensure visited link stays white */
  }

  @media (max-height: 500px) {
    font-size: 14px;
    padding: clamp(10px, 2vw, 5px) clamp(30px, 5vw, 20px);
  }

  @media (max-width: 480px) {
    padding: 10px 30px;
  }
`;

// Title - Adjusts based on screen size
export const Title = styled.div`
  font-size: clamp(18px, 3vw, 18px); /* Scales dynamically */
  line-height: 1.5;
  color: #000;
  margin: 10px 0px 0px;
  font-family: ${fonts.regular};
  text-align: left;
  @media (max-height: 500px) {
    font-size: 18px; /* Smaller font size on very small screens */
  }
`;

// ButtonContainer - Center buttons
export const ButtonContainer = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 16px;
  margin-bottom: 6px;

  div {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: clamp(14px, 3vw, 18px); /* Scales dynamically */
    line-height: 22.1px;
    font-family: ${fonts.regular};
    @media (min-width: ${breakpoints.desktop}) {
      width: 55%;
    }
    a {
      text-align: center;
      color: ${colors.$ffffff} !important;
      @media (min-width: ${breakpoints.desktop}) {
        width: 100%;
      }

    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: column;
    font-size: 14px;
    margin-top: 18px;
  }
  @media (min-width: ${breakpoints.desktop}) {
   margin-top: 16px;
    margin-bottom: 6px;
    flex-direction: row;
    width: 100%;
  }
`;

// BodyContainer - Handles content padding
export const BodyContainer = styled.div`
  max-width: clamp(90%, 80vw, 95%);

  @media (min-width: ${breakpoints.tablet}) {
    padding: 0;
    margin: 50px 60px;
  }
  @media (min-width: ${breakpoints.desktop}) {
    padding: 0;
  }
`;

